// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Anta&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Anta&family=Chelsea+Market&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RygkJgZmBHTETlLP3C3i {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 5rem;
  background-image: url("https://i.imgur.com/GZAmRtb.jpeg");
  background-size: cover;
  border-radius: 2vmin;
}
.RygkJgZmBHTETlLP3C3i .G63iAFm_Sx9MesTpELnN {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.RygkJgZmBHTETlLP3C3i .G63iAFm_Sx9MesTpELnN .r39ZnE9BAUvWgkblnuBG {
  font-size: 4vmin;
  margin-left: auto;
  margin-right: auto;
  color: yellow;
  font-family: "Chelsea Market", sans-serif;
  text-shadow: 2px 2px 1px black;
}
.RygkJgZmBHTETlLP3C3i .G63iAFm_Sx9MesTpELnN .wNjM3vLMM025zBTHZF61 {
  margin-top: 4vmin;
  font-size: 3.5vmin;
  padding: 0.5rem;
  width: 15vmin;
  background-color: red;
  border-radius: 20px;
  font-family: "Anta", sans-serif;
  text-align: center;
  color: white;
  text-shadow: 2px 2px 1px black;
  cursor: pointer;
}
.RygkJgZmBHTETlLP3C3i .G63iAFm_Sx9MesTpELnN .wNjM3vLMM025zBTHZF61:hover {
  background-color: lightblue;
  color: red;
  text-shadow: 2px 2px 1px black;
}`, "",{"version":3,"sources":["webpack://./src/pages/AuthPage/AuthPage.module.scss"],"names":[],"mappings":"AAIA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;EACA,yDAAA;EACA,sBAAA;EACA,oBAAA;AADJ;AAGI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AADN;AAGM;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,yCAAA;EACA,8BAAA;AADR;AAGM;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,+BAAA;EACA,kBAAA;EACA,YAAA;EACA,8BAAA;EACA,eAAA;AADR;AAGM;EACE,2BAAA;EACA,UAAA;EACA,8BAAA;AADR","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Anta&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Anta&family=Chelsea+Market&display=swap');\n\n\n.AuthPage {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 5rem;\n    background-image: url('https://i.imgur.com/GZAmRtb.jpeg');\n    background-size: cover;\n    border-radius: 2vmin;\n\n    .header {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n\n      .title {\n        font-size: 4vmin;\n        margin-left: auto;\n        margin-right: auto;\n        color: yellow;\n        font-family: \"Chelsea Market\", sans-serif;\n        text-shadow: 2px 2px 1px black;\n      }\n      .toggle {\n        margin-top: 4vmin;\n        font-size: 3.5vmin;\n        padding: .5rem;\n        width: 15vmin;\n        background-color: red;\n        border-radius: 20px;\n        font-family: \"Anta\", sans-serif;\n        text-align: center;\n        color: white;\n        text-shadow: 2px 2px 1px black;\n        cursor: pointer;\n      }\n      .toggle:hover {\n        background-color: lightblue;\n        color: red;\n        text-shadow: 2px 2px 1px black;\n      }\n    }\n  }\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"AuthPage": `RygkJgZmBHTETlLP3C3i`,
	"header": `G63iAFm_Sx9MesTpELnN`,
	"title": `r39ZnE9BAUvWgkblnuBG`,
	"toggle": `wNjM3vLMM025zBTHZF61`
};
export default ___CSS_LOADER_EXPORT___;
